import { useNavigate } from 'react-router-dom'

export function TopBar() {
  const navigate = useNavigate()

  return (
    <header className="flex shrink-0 items-center justify-center md:justify-start bg-primary py-1 pt-[env(safe-area-inset-top,0px)] shadow-sm">
      <div className="flex md:w-56 items-center justify-center">
        <img
          src="/logo.png"
          alt="PEPS"
          className="h-9 w-auto cursor-pointer mb-1"
          onClick={() => navigate('/dashboard')}
        />
      </div>
    </header>
  )
}
